<div class="space-y-6">
  <app-page-header
    [backTo]="['/roles']"
    backLabel="Retour à la liste"
    title="Nouveau rôle"
    subtitle="Crée un rôle dans le realm Keycloak. Les permissions et les utilisateurs sont rattachés ensuite."
  />

  <app-role-form
    mode="create"
    [submitting]="submitting()"
    [serverError]="serverError()"
    (save)="onSave($event)"
    (cancel)="onCancel()"
  />
</div>
